class InlineUserDashboardState {
    card = null;
    entries = null;
    addressChangeInitialPrice = null;
    addressChangeFinalPrice = null;
}

export const inlineUserDashboardState = new InlineUserDashboardState();
